import styled, { css } from 'styled-components'

export const ChecklistFormContainer = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const ChecklistsWrap = styled.div``

export const ButtonContainer = styled.div`
  width: 182px;

  ${(p) =>
    p.expanded &&
    css`
      width: 212px;

      & button {
        text-wrap: nowrap;
      }
    `}
`
